import React from 'react';
import { HOME_COUNTRIES } from '../utils/countryConfig';
import '../styles.css';

function Home({ onCountrySelect, isAdmin, onOpenAuthSettings }) {
  const countries = HOME_COUNTRIES;

  const styles = {
    container: {
      padding: '1.25rem',
      maxWidth: '420px',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.25rem',
    },
    card: {
      background: '#ffffff',
      borderRadius: '18px',
      padding: '1.25rem',
      boxShadow: '0 12px 32px rgba(0,0,0,0.08)',
    },
    title: {
      fontSize: '1.35rem',
      fontWeight: 600,
      marginBottom: '0.75rem',
      color: '#151515',
    },
    countryGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem',
    },
    countryButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0.85rem 1rem',
      borderRadius: '14px',
      border: '1px solid #e4e4e4',
      background: '#f7f7f7',
      color: '#1f1f1f',
      fontSize: '1.05rem',
      fontWeight: 600,
      cursor: 'pointer',
      transition: 'background 0.15s ease, transform 0.15s ease',
    },
    flag: {
      fontSize: '1.75rem',
      marginRight: '0.75rem',
    },
    exchangeButton: {
      width: '100%',
      padding: '0.95rem',
      borderRadius: '14px',
      border: 'none',
      color: '#fff',
      fontSize: '1.05rem',
      fontWeight: 600,
      cursor: 'pointer',
      background: '#0f6ef4',
      transition: 'opacity 0.15s ease',
    },
    secondary: {
      background: '#1e293b',
    },
  };

  return (
    <div style={styles.container}>
      <section style={styles.card}>
        <h2 style={styles.title}>天藍小舖 海外連線系統</h2>
        <div style={styles.countryGroup}>
          {countries.map((country) => (
            <button
              key={country.id}
              style={styles.countryButton}
              onClick={() => onCountrySelect(country.id)}
            >
              <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span style={styles.flag}>{country.flag}</span>
                {country.label}
              </span>
              <span style={{ fontSize: '1.25rem', color: '#8b8b8b' }}>›</span>
            </button>
          ))}
        </div>
      </section>

      <section style={styles.card}>
        <h2 style={styles.title}>換貨管理系統</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <button
            type="button"
            style={styles.exchangeButton}
            onClick={() => onCountrySelect('tianlan-exchange')}
          >
            進入換貨後台
          </button>
          <button
            type="button"
            style={{ ...styles.exchangeButton, ...styles.secondary }}
            onClick={() => window.open('/tianlan/customer', '_blank', 'noopener')}
          >
            客戶查詢頁
          </button>
        </div>
      </section>

      {isAdmin && (
        <section style={styles.card}>
          <h2 style={styles.title}>管理員設定</h2>
          <button
            type="button"
            style={{ ...styles.exchangeButton, background: '#334155' }}
            onClick={onOpenAuthSettings}
          >
            設定工作人員登入密碼
          </button>
        </section>
      )}
    </div>
  );
}

export default Home;
